import { render, staticRenderFns } from "./showTwo.vue?vue&type=template&id=3a1fe2b5&scoped=true&"
import script from "./showTwo.vue?vue&type=script&lang=js&"
export * from "./showTwo.vue?vue&type=script&lang=js&"
import style0 from "./showTwo.vue?vue&type=style&index=0&id=3a1fe2b5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1fe2b5",
  null
  
)

export default component.exports